import { useEffect, useRef } from "react";
import { useNavigate } from "@tanstack/react-router";

import type { SocialProviderType } from "lib/auth/authClient";
import { trackSocialSignIn } from "./ExternalSignInButtons";

/**
 * Starts the sign-in named in `?provider=` on load, tracked like a button press. The param is then
 * replaced out of history so Back shows the form rather than redirecting again.
 */
export function useLinkedProvider(
  provider: SocialProviderType | undefined,
  mode: "login" | "register",
  start: (provider: SocialProviderType) => void,
) {
  const navigate = useNavigate();
  // `start` changes every render and StrictMode double-mounts; this keeps it to one hand-off.
  const started = useRef(false);

  useEffect(() => {
    if (!provider || started.current) return;
    started.current = true;
    trackSocialSignIn(mode, provider);
    start(provider);
    void navigate({
      to: mode === "login" ? "/auth/login" : "/auth/register",
      search: (prev) => ({ ...prev, provider: undefined }),
      replace: true,
    });
  }, [provider, mode, navigate, start]);
}
